<section>
    <div class="thank-you-container d-flex min-vh-100">
    <div class="thank-you-content flex-grow-1">


        <!-- Main Content Section -->
        <div class="content-section">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-12 col-lg-8 col-xl-6">
                        <div class="text-center">
                            <!-- Success Icon -->
                            <div class="success-icon fade-in mb-4">
                                <div class="check-circle pt-5">
                                    <svg class="check-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                        <path d="M20 6L9 17l-5-5"/>
                                    </svg>
                                </div>
                            </div>

                            <!-- Thank You Title -->
                            <h1 class="thank-you-title fade-in-delay">
                                THANK YOU!
                            </h1>
                            
                            <!-- Completion Message -->
                            <h2 class="completion-message fade-in-delay-2">
                                Your assessment is completed.
                            </h2>

                            <!-- Personal Message -->
                            <p class="personal-message fade-in-delay-2" *ngIf="userName">
                                Thank you, <span class="user-name">{{ userName }}</span>, for taking the time to complete your assessment.
                            </p>
                            
                            <!-- Assessment Details -->
                            <div class="assessment-details fade-in-delay-3" *ngIf="assessmentName">
                                <p class="assessment-info">
                                    <strong>Assessment:</strong> {{ assessmentName }}
                                </p>
                                <!-- <p class="completion-time">
                                    <strong>Completed on:</strong> {{ completionTime | date:'medium' }}
                                </p> -->
                            </div>

                            <!-- Information Message -->
                            <div class="info-message fade-in-delay-3 mt-4">
                                <p class="description">
                                    Your responses have been recorded and will be analyzed to provide you with valuable insights 
                                    about your work style and behavioral patterns.
                                </p>
                            </div>

                            <!-- Action Buttons -->
                            <div class="action-buttons fade-in-delay-4 mt-5">
                                <div class="row justify-content-center">
                                    <div class="col-12 col-md-8">
                                        <div class="button-group">
                                            <!-- Primary Action -->
                                            <button type="button" 
                                                    class="btn btn-primary btn-lg rounded-pill mb-3 me-3"
                                                    (click)="goToDashboard()">
                                                Back to Dashboard
                                            </button>

                                            <!-- Secondary Actions -->
                                            <div class="secondary-actions mt-4">
                                                <button type="button" 
                                                        class="btn btn-outline-primary btn-md rounded-pill me-3"
                                                        (click)="takeAnotherAssessment()">
                                                    Take Another Assessment
                                                </button>
                                                
                                                <button type="button" 
                                                        class="btn btn-outline-secondary btn-md rounded-pill"
                                                        (click)="goToResults()">
                                                    View Results
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Auto-redirect Message -->
                            <!--<div class="auto-redirect-message fade-in-delay-4 mt-4">
                                <p class="text-muted small">
                                    <i class="fa fa-clock-o me-1"></i>
                                    You will be automatically redirected to your dashboard in 10 seconds.
                                </p>
                            </div>-->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</section>